import React, { useState } from "react";
import { Button, Input, Select } from "antd";
import SuccessIcon from "../components/BrandsPartnerComponents/DeleteIcon";
import NavigationButton from "../components/BrandsPartnerComponents/navigation_button";
import SuccessComponent from "../components/BrandsPartnerComponents/SuccessComponent";

const { Option } = Select;



const SuccessBrandsPage: React.FC = () => {
    
  function openMail(): void {
    window.location.href = "mailto:";
  }

  return (
    <SuccessComponent buttonText="Open Mail" message={<span>Thank you for sharing your details! <br/>Please verify your email to activate your account.</span>} title="You’re All Set! 🎉" onButtonClick={openMail} />

   
  );
};

export default SuccessBrandsPage;
